import DownloadIntegrationCallReportRequestModelBase from '../_generated/modelBases/download-integration-call-report-request-model-base';

export default class DownloadIntegrationCallReportRequestModel extends DownloadIntegrationCallReportRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
